import { Checkbox, Chip, FilterOptionsState, TextField } from '@mui/material';
import MuiAutocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import styles from './MultipleAutocomplete.module.scss'
import { IOption } from '../../utils';
import clsx from 'clsx';
import { ComponentProps } from 'react';
import CheckInput from '../CheckInput/CheckInput';

interface IAutocomplete<T> extends ComponentProps<"span"> {
  value: IOption<T>[]
  setValue: (val: IOption<T>[]) => void
  options: IOption<T>[]
  label: string
  className?: string
  style?: Object
  onFocus?: () => void
  onBlur?: () => void
}

function MultipleAutocomplete<T=string>(props: IAutocomplete<T>)  {
  const {value, setValue, label, options, className, style, onFocus, onBlur} = props
  const filterOptions = createFilterOptions<IOption<T>>()

  return (
    <MuiAutocomplete
      value={value}
      onChange={(_e, val) => {
        if (val) {
          setValue(val)
        }
      }}
      options={options}
      renderInput={(params) => <TextField {...params} label={label} />}
      className={clsx(styles.root, className)}
      style={style}
      onFocus={onFocus}
      onBlur={onBlur}  
      multiple={true}
      disableCloseOnSelect
      limitTags={0}
      getLimitTagsText={more => <p>Выбрано: {more}</p>}
      filterOptions={(options, state) => {
        return filterOptions(options, state).slice(0, 100)
      }}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              key={key}
              variant="outlined"
              label={option.label}
              size="small"
              {...tagProps}
              onDelete={undefined}
            />
          );
        })
      }
      renderOption={(props, option, { selected }) => {
        const {...optionProps } = props;
        return (
          <li key={option.label} {...optionProps}>
            <CheckInput
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.label}
          </li>
        );
      }}
    />
  )
}

export default MultipleAutocomplete